// @flow
import React from 'react';
import { Row, Col } from 'reactstrap';
import addDays from 'date-fns/add_days';
import isBefore from 'date-fns/is_before';
import isToday from 'date-fns/is_today';
import isSameDay from 'date-fns/is_same_day';
import isWithinRange from 'date-fns/is_within_range';
import getDay from 'date-fns/get_day/index';
import { parse as parseDate } from 'date-fns';

// Components
import CalendarDay from 'components/atoms/CalendarDay';

type Props = {
  startDate: Date,
  monthIdx: number,
  selectedDate: Date,
  onSelect: () => void,
  availableDays: Array<Object>,
  promotionStartDate: string,
  promotionEndDate: string,
  promotionDaysOfWeek: Array<string>
};

const CalendarWeek = ({
  startDate,
  monthIdx,
  selectedDate,
  onSelect,
  availableDays,
  promotionStartDate,
  promotionEndDate,
  promotionDaysOfWeek
}: Props) => {
  const days = [];
  let date;
  let i, j;
  let promotion = false;
  let promotionToday = false;

  for (i = 0; i < 7; i += 1) {
    date = addDays(startDate, i);
    let disabled = true;
    const weekDay = getDay(date);
    promotionToday = Boolean(+promotionDaysOfWeek[weekDay]);
    promotion =
      isWithinRange(date, promotionStartDate, promotionEndDate) &&
      promotionToday;

    if (availableDays && (isToday(date) || !isBefore(date, new Date()))) {
      // @TODO optimize
      for (j = 0; j < availableDays.length; j += 1) {
        const { isOpen, timeslots, calendarDate } = availableDays[j];
        if (isSameDay(date, parseDate(`${calendarDate}T00:00:00`))) {
          disabled = !isOpen || !timeslots || timeslots.length === 0;
          break;
        }
      }
    }
    days.push(
      <Col key={date}>
        <CalendarDay
          date={date}
          disabled={disabled}
          active={isSameDay(date, selectedDate)}
          onClick={onSelect}
          promotion={promotion}
        />
      </Col>
    );
  }
  return <Row>{days}</Row>;
};

CalendarWeek.defaultProps = {
  onSelect: () => {}
};

export default CalendarWeek;



// WEBPACK FOOTER //
// ./src/components/molecules/CalendarWeek/CalendarWeek.js